// @flow
import React from 'react';
import classnames from 'classnames';
import { get } from 'lodash';

export type OfferDiscountProps = {
  className?: string,
  discount: ?{
    amount?: {
      formattedValue: string,
      value?: number,
    },
    offerColor?: Colors,
    offerName?: string,
  },
  i18n: {
    defaultLabel?: string,
    defaultColor?: Colors,
  },
};

export function OfferDiscount(props: OfferDiscountProps) {
  const { className, discount = {}, i18n = {} } = props;

  const offerName = (discount && discount.offerName) || i18n.defaultLabel || '';
  const color = (discount && discount.offerColor) || i18n.defaultColor || '';

  return get(discount, 'amount.value') ? (
    <div
      className={classnames(className, 'bg-current font-bold p-1 text-center text-sm uppercase', {
        [`text-${color}`]: color,
      })}
      style={{ backgroundColor: color }}
    >
      <span className="text-white">{offerName}</span>
    </div>
  ) : null;
}
